import { useCallback } from "react";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { SearchByDetailLayout } from "../../../_shared";

import type * as Model from "../../model";

type Props = {
	searchModel: Model.Type.SearchModel;

	// 詳細検索のメルマガ配信希望者フラグの変更
	onChangeIsAcceptMailMagazineChecked: (value: boolean) => void;
	// 詳細検索の現地決済者フラグの変更
	onChangeIsLocalPaymentChecked: (value: boolean) => void;
};

export const SearchByDetailConditionsComposition = ({
	searchModel,
	//
	// 詳細検索のメルマガ配信希望者フラグの変更
	onChangeIsAcceptMailMagazineChecked,
	// 詳細検索の現地決済者フラグの変更
	onChangeIsLocalPaymentChecked,
}: Props) => {
	/**
	 * 詳細検索のメルマガ配信希望者フラグの変更
	 */
	const handleChangeIsAcceptMailMagazineChecked = useCallback(
		(value: boolean) => {
			onChangeIsAcceptMailMagazineChecked(value);
		},
		[onChangeIsAcceptMailMagazineChecked],
	);
	/**
	 * 詳細検索の現地決済者フラグの変更
	 */
	const handleChangeIsLocalPaymentChecked = useCallback(
		(value: boolean) => {
			onChangeIsLocalPaymentChecked(value);
		},
		[onChangeIsLocalPaymentChecked],
	);

	return (
		<SearchByDetailLayout>
			{/* メルマガ配信希望の予約 */}
			<CheckboxField
				value={searchModel.isAcceptMailMagazineChecked}
				label="メルマガ配信希望の予約を表示"
				handleChange={handleChangeIsAcceptMailMagazineChecked}
			/>

			{/* 現地決済者の予約 */}
			<CheckboxField
				value={searchModel.isLocalPaymentChecked}
				label="現地決済者の予約を表示"
				handleChange={handleChangeIsLocalPaymentChecked}
			/>
		</SearchByDetailLayout>
	);
};
